import React, { useState } from 'react'
import "./style.scss"
import PackageItem from '../PackageItem'
import { ArrowLeftPagingSVG, ArrowRigthPagingSVG } from '../../../../components/IconSvg'
import { useTranslation } from 'react-i18next'
// const list = [{ title: "slider1", }, { title: "slider2", }, { title: "slider3", }, { title: "slider4", }, { title: "slider5", }
// ]
const Slider = ({ list, selectItem, selected, handleActivePackage, activePackagePending, idActiveClick, mobileMood, duration, from }) => {
    const [selectedItem, setSelectedItem] = useState(0)
    const { i18n } = useTranslation()

    const toUp = () => {
        if (selectedItem !== list.length - 3) {
            setSelectedItem(selectedItem + 1)

        }
    }
    const toDown = () => {
        if (selectedItem >= 1) {
            setSelectedItem(selectedItem - 1)

        }
    }

    return (
        <div className='d-flex justify-content-center slider-container'>
            {!mobileMood ? <>
                {
                    ((selectedItem >= 1 && i18n.language === 'fa') || (i18n.language === 'en' && selectedItem < list.length - 4)) &&
                    <div  >
                        <button className={`paging-icon-holder right d-flex flex-row justify-content-center `} onClick={i18n.language === 'fa' ? toDown : toUp}>
                            <span className='paging-icon'><ArrowRigthPagingSVG /> </span></button>
                    </div>}
                <div className={`slider ${mobileMood ? 'mobile-device' : ''}`} >
                    <div className='slider-items-context' style={{ transform: `translateX(${i18n.language === 'en' ? '-' : ''}${(344 * selectedItem)}px)` }} >
                        {list.map((item, idx) => {
                            return (
                                <div
                                    key={idx}
                                >
                                    <PackageItem
                                        {...item}
                                        selectItem={() => selectItem(item)}
                                        selected={item === selected}
                                        handleActivePackage={handleActivePackage}
                                        activePackagePending={activePackagePending}
                                        idActiveClick={idActiveClick}
                                        duration={duration}
                                    />
                                </div>
                            )
                        })}
                    </div>

                </div>
                {((selectedItem <= list.length - 4 && i18n.language === 'fa') || (i18n.language === 'en' && selectedItem >= 1)) && <button className={`paging-icon-holder left`}
                    onClick={i18n.language === 'fa' ? toUp : toDown}>
                    <span className='paging-icon'> <ArrowLeftPagingSVG /> </span></button>}
            </> :
                <div>
                    {list.map((listItem, idx) =>
                        <PackageItem
                            {...listItem}
                            key={idx}
                            selectItem={() => selectItem(listItem)}
                            selected={listItem === selected}
                            handleActivePackage={handleActivePackage}
                            activePackagePending={activePackagePending}
                            idActiveClick={idActiveClick}
                            duration={duration}
                        />
                    )}

                </div>}



        </div>

    )
}

export default Slider